import api from './axios';

export const getRoutines = (params) => api.get('/routines', { params });
export const getRoutineAssignableUsers = (params) => api.get('/routines/assignable-users', { params });
export const createRoutine = (data) => api.post('/routines', data);
export const updateRoutine = (id, data) => api.put(`/routines/${id}`, data);
export const toggleRoutineActive = (id) => api.patch(`/routines/${id}/toggle-active`);
export const deleteRoutine = (id) => api.delete(`/routines/${id}`);

export const getRoutineExecutions = (params) => api.get('/routine-executions', { params });
export const completeRoutineExecution = (id, data) => api.patch(`/routine-executions/${id}/complete`, data);
export const overrideRoutineExecution = (id, data) => api.patch(`/routine-executions/${id}/override`, data);
